import { useState } from 'react';

const MCQ = ({ index, question, submitted }) => {
  
    const [selection, setSelection] = useState(null)
  
    const alphabets = ['a', 'b', 'c', 'd']
  
    const handleSelect = (option) => {
      setSelection(option)
    }
  
    const evaluationClass = (option) => {
      if (!submitted) return ""
      if (option === question.correctoption) return " correct"
      else if (option === selection && option !== question.correctoption) return " wrong"
      else return ""
    }
  
    return (
      <div className='mcq'>
        <p className='question'>{index+1}. {question.question}</p>
        <ul>
            {alphabets.map((char, _) => 
                <label>
                <input type='radio' name={'answer_'+index} onClick={() => handleSelect(char)} disabled={submitted}/>
                <div className={'option' + evaluationClass(char)}><span className='char'>{char}</span> {question.options[char]}</div>
                </label>
            )}
        </ul>
      </div>
    )
  
}

export default MCQ
  